import I from "./index216.mjs";
import { serializeStyles as x } from "./index558.mjs";
import { useInsertionEffectAlwaysWithSyncFallback as R } from "./index557.mjs";
import { getRegisteredStyles as A, registerStyles as D, insertStyles as j } from "./index556.mjs";
import * as c from "react";
import U from "./index644.mjs";
import { w as V, T as W } from "./index441.mjs";
var q = U, B = function(e) {
  return e !== "theme";
}, b = function(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96 ? q : B;
}, O = function(e, a, i) {
  var r;
  if (a) {
    var o = a.shouldForwardProp;
    r = e.__emotion_forwardProp && o ? function(l) {
      return e.__emotion_forwardProp(l) && o(l);
    } : o;
  }
  return typeof r != "function" && i && (r = e.__emotion_forwardProp), r;
}, G = function(e) {
  var a = e.cache, i = e.serialized, r = e.isStringTag;
  return D(a, i, r), R(function() {
    return j(a, i, r);
  }), null;
}, X = function f(e, a) {
  var i = e.__emotion_real === e, r = i && e.__emotion_base || e, o, l;
  a !== void 0 && (o = a.label, l = a.target);
  var p = O(e, a, i), S = p || b(r), w = !S("as");
  return function() {
    var d = arguments, s = i && e.__emotion_styles !== void 0 ? e.__emotion_styles.slice(0) : [];
    if (o !== void 0 && s.push("label:" + o + ";"), d[0] == null || d[0].raw === void 0)
      s.push.apply(s, d);
    else {
      var F = d[0];
      s.push(F[0]);
      for (var z = d.length, v = 1; v < z; v++)
        s.push(d[v], F[v]);
    }
    var n = V(function(t, u, _) {
      var g = w && t.as || r, m = "", C = [], h = t;
      if (t.theme == null) {
        h = {};
        for (var N in t)
          h[N] = t[N];
        h.theme = c.useContext(W);
      }
      typeof t.className == "string" ? m = A(u.registered, C, t.className) : t.className != null && (m = t.className + " ");
      var T = x(s.concat(C), u.registered, h);
      m += u.key + "-" + T.name, l !== void 0 && (m += " " + l);
      var E = w && p === void 0 ? b(g) : S, y = {};
      for (var P in t)
        w && P === "as" || E(P) && (y[P] = t[P]);
      return y.className = m, _ && (y.ref = _), /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(G, {
        cache: u,
        serialized: T,
        isStringTag: typeof g == "string"
      }), /* @__PURE__ */ c.createElement(g, y));
    });
    return n.displayName = o !== void 0 ? o : "Styled(" + (typeof r == "string" ? r : r.displayName || r.name || "Component") + ")", n.defaultProps = e.defaultProps, n.__emotion_real = n, n.__emotion_base = r, n.__emotion_styles = s, n.__emotion_forwardProp = p, Object.defineProperty(n, "toString", {
      value: function() {
        return "." + l;
      }
    }), n.withComponent = function(t, u) {
      var _ = f(t, I({}, a, u, {
        shouldForwardProp: O(n, u, !0)
      }));
      return _.apply(void 0, s);
    }, n;
  };
};
export {
  X as default
};
